/** A set of manufacturer names and the user responsible for all of them. */
export class ManufacturerResponsible {
  names: string[] = [];
  responsible: string = "";
}

/**
 * Single document holding every set of manufacturer names together with its
 * responsible. Stored in the customer's config database.
 */
export class ManufacturerResponsibles {
  _id?: string;
  _rev?: string;
  type?: string = "manufacturerResponsibles";
  responsibles: ManufacturerResponsible[] = [];
}

/**
 * One row of the excel import - the sets are built by grouping the rows that
 * share a responsible.
 */
export class ManufacturerResponsibleRow {
  [key: string]: any;
  manufacturerName: string = "";
  responsible: string = "";
}
